import { gql } from '@apollo/client';

export const GET_FOLLOWING = gql`
  query following {
    following {
      communities
      authors
    }
  }
`;
